<template>
  <div class="step_process">
    <div v-show="showStep" class="step">
      <ul>
        <li :id="motorPage === '1' ? 'atpresent' : ''" class="routeL" :class="motorSchedule >= 1 ? 'motorSchedule' : ''" @click="toPages('1')">
          <p>1</p>
          <span>基础信息</span>
        </li>
        <li :id="motorPage === '2' ? 'atpresent' : ''" class="routeL" :class="motorSchedule >= 2 ? 'motorSchedule' : ''" @click="toPages('2')">
          <p>2</p>
          <span>人员信息</span>
          <div />
        </li>
        <li :id="motorPage === '3' ? 'atpresent' : ''" class="routeL" :class="motorSchedule >= 3 ? 'motorSchedule' : ''" @click="toPages('3')">
          <p>3</p>
          <span>报价</span>
          <div />
        </li>
        <li :id="motorPage === '4' ? 'atpresent' : ''" class="routeL" :class="motorSchedule >= 4 ? 'motorSchedule' : ''" @click="toPages('4')">
          <p>4</p>
          <span>补充信息</span>
          <div />
        </li>
      </ul>
    </div>
    <div>
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <!-- 可回溯提示谈框 -->
    <van-popup v-model="showTracBack" style="border-radius: 8px;" :close-on-click-overlay="isClose">
      <div class="TracBackTicket">
        <div class="box">
          <div class="title">
            温馨提示
          </div>
          <div class="context">
            <div>① 您即将进入投保流程</div>
            <div>② 请仔细阅读并确认保险条款等相关内容</div>
            <div>③ 您的投保操作将被记录</div>
          </div>
          <div class="agreeBtn" @click="agree">
            同意
          </div>
        </div>
      </div>
    </van-popup>
    <!--山西专属-->
    <van-popup v-model="showShanXi" style="border-radius: 8px;" :close-on-click-overlay="isClose">
      <div class="TracBackTicket TracBackTickets">
        <div class="box">
          <div class="title">
            温馨提示
          </div>
          <div class="context">
            <div>① 本系统目前仅支持上一保单年度在我公司投保的客户办理续保服务，资料需提前准备好行车本正副本，身份证正反面。</div>
            <div style="padding-top: .06rem;box-sizing: border-box;">② 如果您是首次选择我公司，请致电客服热线<a href="tel:0351-4937189" style="font-weight: bold;">0351-4937189</a>，前往附近营业网点现场办理投保手续。</div>
            <div style="padding-bottom: .06rem;">工作时间为9:00-11:30, 14:30-17:00。</div>
            <div>③ 感谢您的理解与支持！</div>
          </div>
          <div class="agreeBtn" @click="shanXiConfirm">
            确定
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import api from '@/api/api.js'
// import commonUtils from '@/utils/common.js'
export default {
  data() {
    return {
      motorPage: '1',
      motorSchedule: '1',
      showStep: true,
      // 可回溯
      isClose: false,
      showTracBack: false,
      showShanXi: false // 陕西专属弹框
    }
  },
  computed: {
    getStep() {
      return this.$store.state.motorStep
    },
    getShowStep() {
      return this.$store.state.showStep
    }
  },
  watch: {
    'getStep': function(newVal, oldVal) {
      this.motorPage = newVal
      this.$store.commit('set_motorPage', this.motorPage)
      if (newVal > this.motorSchedule) {
        this.motorSchedule = newVal
      }
      if (newVal === '1') {
        this.$router.push('/motor/baseInfo')
      } else if (newVal === '2') {
        this.$router.push('/motor/personInfo')
      } else if (newVal === '3') {
        this.$router.push('/motor/motorQuote')
      } else if (newVal === '4') {
        this.$router.push('/motor/motorSupplementary')
      }
    },
    'getShowStep': function(newVal, oldVal) {
      this.showStep = newVal
    },
    '$route': {
      handler(to, from) {
        if (to.path === '/motor/motorSupplementary') {
          this.motorPage = '4'
          this.motorSchedule = '4'
        } else if (to.path === '/motor/motorQuote') {
          this.motorPage = '3'
          this.motorSchedule = '3'
        } else if (to.path === '/motor/personInfo') {
          this.motorPage = '2'
          this.motorSchedule = '2'
        } else {
          this.motorPage = '1'
          this.motorSchedule = '1'
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // this.$store.commit('set_motorStep', '1')
    this.$store.commit('set_motorStep', 0)
    // 20200919做可回溯判断
    // this.getTraceBack()
    const comName = localStorage.getItem('setMotorAreaName')
    console.log(comName, 'comNamecomName')
    if (comName === 'SHAN_XI') {
      this.showShanXi = true
    } else {
      this.showTracBack = true
    }
  },
  methods: {
    shanXiConfirm() {
      this.showShanXi = false
      this.showTracBack = true
    },
    toPages(step) {
      if (step > Number(this.motorSchedule)) {
        return ''
      }
      const wayList = new Map([
        ['1', '/motor/baseInfo'],
        ['2', '/motor/personInfo'],
        ['3', '/motor/motorQuote'],
        ['4', '/motor/motorSupplementary']
      ])
      console.log(wayList.get(step), 'wayList.get(step)')
      this.$router.push(wayList.get(step))
    },
    // 可回溯
    getTraceBack() {
      console.log('get trace back flag')
      // this.$store.commit('setMotorTraceBack', true)
      // this.showTracBack = true
      // try {
      //   this.$http.post(api.getByCodeType, { codeType: 'TraceableSwitch' })
      //     .then(res => {
      //       const result = res.data || []
      //       for (const item in result) {
      //         if (result[item].codeType === 'TraceableSwitch') {
      //           // 如果进行可回溯 （返回的可能是1  也可能是 '1'）
      //           if (result[item].codeCode === '1') {
      //             // tip--上生产后此处需要修改js的路径
      //             // 在设置了可回溯标识为1 并且进来的是C端用户时，才进行可回溯
      //             console.log(commonUtils.isClient(), 'commonUtils.isClient()')
      //             if (commonUtils.isClient()) {
      //               this.$store.commit('setMotorTraceBack', true)
      //               this.showTracBack = true
      //               // let jsURl = 'https://staticdaily.zhongan.com/website/isee-poc/eye.js'
      //               // 根据环境变量判断，如果是生产环境，则加载生产环境地址，否则加载sit地址
      //               let jsURl = ''
      //               if (process && process.env && process.env.ENV_CONFIG === 'prod') {
      //                 jsURl = 'https://saletrace.zking.com/eye.js'
      //               } else {
      //                 jsURl = 'https://test-saletrace.zking.com:20001/eye.js'
      //               }
      //               commonUtils.loadJs(jsURl)
      //             }
      //           }
      //         }
      //       }
      //     })
      // } catch (e) {
      //   console.log(e, '可回溯的')
      // }
    },
    agree() {
      this.showTracBack = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/motor/index.vue